<template>
	<div>
		<el-dialog :show-close="false" :visible="payModal" destroy-on-close title="微信支付" width="35%" @before-close="handleClose">
			<div style="overflow: hidden">
				<div class="tab-pane-left">
					<div>扫一扫付款（元）</div>
					<div class="money">{{ total.toFixed(2) }}</div>
					<div id="wechat-qrcode" class="qrcode"></div>
					<div>订单号：{{ orderNum }}</div>
				</div>
				<div class="tab-pane-right">
					<div class="tab-pane-right-img">
						<img alt="" src="../../assets/images/weChatPay.png" />
					</div>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import QRCode from 'qrcodejs2';
	export default {
		name: 'WeChatPay',
		props: {
			total: {
				type: Number,
				default: 0
			},
			orderNum: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				//支付modal
				payModal: false,
				//定时关闭时间(秒)
				timerLength: 60
			};
		},
		watch: {
			//监听modal的显现
			payModal(val) {
				if (val) {
					
				} else {
					clearInterval(this.timer);
				}
			},

			//监听支付剩余时间
			timerLength(val) {
				if (val <= 0) {
					this.payModal = false;
					clearInterval(this.timer);
					this.timerLength = 60;
				}
			}
		},
		methods: {
			//微信支付
			wechatQrcode(qrCode) {
				document.getElementById('wechat-qrcode').innerHTML = '';
				let qrcode = new QRCode(document.getElementById('wechat-qrcode'), {
					width: 198,
					height: 198,
					text: qrCode // 二维码内容
				});
			},

			//支付定时轮循
			createTimer() {
				this.timer = setInterval(() => {
					this.timerLength -= 3;
					getOrderCheck(this.orderNum).then(res => {
						if (res.code == 200) {
							if (res.data) {
								if (res.data.status == 2) {
									setTimeout(() => {
										this.$Modal.success({
											title: '提示',
											content: '支付成功',
											onOk: () => {
												clearInterval(this.timer);
												this.payModal = false;
												this.$emit('Success');
											}
										});
									}, 300);
								}
							}
						}
					});
				}, 3000);
			},

			//关闭支付弹框
			handleClose() {
				clearInterval(this.timer);
				this.payModal = false;
				this.$emit('Success');
				this.timerLength = 60;
			}
		}
	};
</script>

<style lang="less" scoped>
	.money {
		font-size: 26px;
		font-weight: 700;
		color: #f60;
	}

	.qrcode {
		display: inline-block;
		margin: 10px;
		overflow: hidden;
		width: 198px;
		height: 198px;
	}

	.pay-title {
		color: #4f8dfe;
		text-wechatgn: center;
		line-height: 30px;
		font-size: 16px;
	}

	.tab-pane-left {
		width: 50%;
		float: left;
	}

	.tab-pane-right {
		width: 49%;
		float: left;
		height: 100%;
	}

	.tab-pane-right-img {
		width: 85%;
		height: 100%;
		margin: 0 auto;
	}

	.tab-pane-right-img img {
		height: 100%;
		width: 100%;
	}

	/deep/ .el-dialog__header {
		border-bottom: 1px solid #e8e8e8;
		margin-right: 0;
		background: #f5f7fa;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #3a434f;
		font-size: 24px;
	}

	/deep/ .el-dialog__footer {
		border-top: 1px solid #e8e8e8;
		padding: 18px;
	}

	/deep/ .el-dialog__body .el-form-item__label {
		line-height: 26px;
	}
</style>
